import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import QRCode from "../QRCode/qrcode.jpg";
import EmailIcon from '@mui/icons-material/Email';
import { toWords } from 'number-to-words';

const NongstBillPrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '2px',
        width: '600px',
        height: '900px',
        margin: '5px auto',
    };

  

    if (!labelData || labelData.length === 0) {
        return null;
    }

    const firstItem = labelData[0];

    const NumberToWords = (num) => {
        const belowTwenty = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const thousands = ["", "Thousand", "Lakh", "Crore"];

        const convert = (n) => {
            if (n === 0) return "";
            if (n < 20) return belowTwenty[n] + " ";
            if (n < 100) return tens[Math.floor(n / 10)] + " " + belowTwenty[n % 10] + " ";
            if (n < 1000) return belowTwenty[Math.floor(n / 100)] + " Hundred " + (n % 100 !== 0 ? convert(n % 100) : "");

            // Corrected loop for thousands
            for (let i = 0; i < thousands.length; i++) {
                const divisor = Math.pow(1000, i + 1); // 1000, 100000, 10000000...
                if (n < divisor) {
                    const currentDivisor = Math.pow(1000, i); // Get the current divisor (1000, 100000, etc.)
                    return convert(Math.floor(n / currentDivisor)) + " " + thousands[i] + " " + (n % currentDivisor !== 0 ? convert(n % currentDivisor) : "");
                }
            }
        };

        return convert(num).trim();
    };

    const AmountInWords = ({ amount }) => {
        const cleanedAmount = parseFloat(amount || 0).toFixed(2); // Ensure amount is valid
        const [rupees, decimal = "00"] = cleanedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))}Only</h5>
                {parseInt(decimal) > 0 && (
                    <p>{NumberToWords(parseInt(decimal))} Paise Only</p>
                )}
            </div>
        );
    };
  

    return (
        <div style={{ ...containerStyle, width: '600px', height: '820px', padding: '20px' }}>
          
            {firstItem && firstItem.CounterSalePrint && (
                <div>
                    <h5 style={{ textAlign: 'center', marginBottom: '10px', color: 'blue', fontWeight: 'bold' }}>
                        {firstItem.CounterSalePrint.CompanyName}
                    </h5>

                    <div style={{ marginBottom: '5px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <PlaceIcon style={{ color: 'green', width: '25px', height: '25px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'bolder', fontSize: '14px' }}>
                                {firstItem.CounterSalePrint.Address}, {firstItem.CounterSalePrint.Address1},{firstItem.CounterSalePrint.Location} - {firstItem.CounterSalePrint.Pincode}
                            </span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <PhoneIcon style={{ color: 'blue', width: '25px', height: '25px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'bolder', fontSize: '14px' }}>
                                {firstItem.CounterSalePrint.CompanyContactNumber} {firstItem.CounterSalePrint.Email}
                            </span>
                        </div>

                        <div style={{ marginLeft: '5px', marginTop: '10px' }}>
                            <span style={{ fontWeight: 'bolder', fontSize: '14px' }}>
                                GST NO: {firstItem.CounterSalePrint.GSTNumber}
                            </span>
                        </div>
                    </div>
                    <br />
                    {/* QR Code */}
                    <div style={{ position: 'absolute', top: '30px', right: '20px' }}>
                        <img src={QRCode} alt="QR Code" style={{ width: '80px', height: '80px' }} />
                    </div>
                    <br />

                    <hr style={{ border: 'none', borderTop: '1px solid black', margin: '20px -20px', width: 'calc(100% + 40px)',marginTop:'10px' }} />

                    <h2 style={{ textAlign: 'center', marginBottom: '10px', fontSize: '16px', fontWeight: 'bold' }}>
                        {firstItem.CounterSalePrint.IsReprint ? 'ESTIMATE BILL (Reprinted)' : 'ESTIMATE BILL'}
                    </h2>

                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px' }}>Customer: {firstItem.CounterSalePrint.Name}</strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px' }}>Phone No: {firstItem.CounterSalePrint.ContactNumber}</strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px' }}>Place: {firstItem.CounterSalePrint.CustomerAddess}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px' }}>Bill No: {firstItem.CounterSalePrint.prefix}{firstItem.CounterSalePrint.InvoiceNumber}/{firstItem.CounterSalePrint.FinYear}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px' }}>Bill Date: {new Date(firstItem.CounterSalePrint.InvoiceDate).toLocaleDateString('en-GB')}</strong>
                    </div>
                </div>
            )}

            {firstItem && firstItem.CounterSaleprintItems && (
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #000', padding: '5px', fontSize: '12px', width: '50px' }}>Sl No</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontSize: '12px', width: '60px' }}>HSN</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontSize: '12px', width: '200px' }}>Name</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontSize: '12px', width: '70px' }}>Rate</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontSize: '12px', width: '60px' }}>Qty</th>
                            <th style={{ border: '1px solid #000', padding: '5px', fontSize: '12px', width: '100px' }}>Total Amt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {firstItem.CounterSaleprintItems.map((item, index) => (
                            <tr key={index}>
                                <td style={{ border: '1px solid #000', padding: '5px', fontSize: '12px', color: 'black' }}>{index + 1}</td>
                                <td style={{ border: '1px solid #000', padding: '5px', fontSize: '12px',color: 'black' }}>{item.HSNCODE}</td>
                                <td style={{ border: '1px solid #000', padding: '5px', fontSize: '12px',color: 'black' }}>{item.ItemName}</td>
                                <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontSize: '12px', color: 'black' }}>{item.Rate.toFixed(2)}</td>
                                <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'center', fontSize: '12px',color: 'black' }}>{item.Quantity}</td>
                                <td style={{ border: '1px solid #000', padding: '5px', textAlign: 'right', fontSize: '12px', color: 'black' }}>{(item.TotalAmount).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>

                    <tbody>
                        <tr>
                            {/* Bank Details */}
                            <td style={{ border: '1px solid #000', padding: '5px', fontSize: '12px',fontWeight: 'bold', color: 'black' }} colSpan="4">
                                <table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: 'none', padding: '5px', fontSize: '12px',fontWeight: 'bold', color: 'black', textAlign: 'left' }}>BANK: AXIS BANK</th>
                                        </tr>
                                        <tr>
                                            <th style={{ border: 'none', padding: '5px',fontSize: '12px', fontWeight: 'bold',color: 'black', textAlign: 'left' }}>BRANCH: ANGAMALY</th>
                                        </tr>
                                        <tr>
                                            <th style={{ border: 'none', padding: '5px', fontSize: '12px', fontWeight: 'bold',color: 'black', textAlign: 'left' }}>A/C NAME: PETERS RICE MILL</th>
                                        </tr>
                                        <tr>
                                            <th style={{ border: 'none', padding: '5px', fontSize: '12px',fontWeight: 'bold', color: 'black', textAlign: 'left' }}>A/C NO: 922030028095826</th>
                                        </tr>
                                        <tr>
                                            <th style={{ border: 'none', padding: '5px', fontSize: '12px', fontWeight: 'bold',color: 'black', textAlign: 'left' }}>IFSC: UTIB0001646</th>
                                        </tr>
                                    </thead>
                                </table>
                            </td>

                            {/* Amount Details */}
                            <td style={{ border: '1px solid #000', padding: '5px', fontSize: '12px',fontWeight: 'bold', color: 'black' }} colSpan="1">
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '5px',fontSize: '12px', fontWeight: 'bold',color: 'black', textAlign: 'left' }}>NetValue</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '5px', fontSize: '12px', fontWeight: 'bold',color: 'black', textAlign: 'left' }}>RoundOff</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '5px', fontSize: '12px',fontWeight: 'bold', color: 'black', textAlign: 'left' }}>GrandTotal</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>

                            <td style={{ border: '1px solid #000', padding: '5px', fontSize: '12px',fontWeight: 'bold', color: 'black' }} colSpan="1">
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '5px', fontSize: '12px',fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.CounterSalePrint.NetAmount).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '5px', fontSize: '12px',fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.CounterSalePrint.RoundOff).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '5px', fontSize: '12px', fontWeight: 'bold',color: 'black', textAlign: 'right' }}>{(firstItem.CounterSalePrint.TotalAmount).toFixed(2)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}

            {firstItem && firstItem.CounterSalePrint && (
                <div>
                    <h3 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' ,fontSize: '12px',}}>
                        <AmountInWords amount={firstItem.CounterSalePrint.TotalAmount} />
                    </h3>
                </div>
            )}

         
        </div>
    );
}
export default NongstBillPrint;
